import appsGetters from './getters'
import appsActions from './actions'
import appsMutations from './mutations'

export default {
  namespaced: true,
  state() {
    return {
      applications: [],
    }
  },
  getters: appsGetters,
  mutations: appsMutations,
  actions: appsActions,
}
